import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BellRing, Bike, CarTaxiFront, FileCheck, QrCode, ShieldCheck, Smartphone } from 'lucide-react';
import { DmpLogo } from '../../brand/DmpLogo';
import { OwnerButton } from '../OwnerShell';
import type { OwnerNav } from '../../../types/owner';
const slides = [{
  title: 'সহজেই আপনার গাড়ি নিবন্ধন করুন',
  body: 'ঘরে বসেই সিএনজি/অটোরিকশা ও মোটরসাইকেলের তথ্য যুক্ত করুন।',
  art: <div className="relative flex h-full items-center justify-center" data-id="element-1767" data-mp="2dluq7o10a1yf">
        <span className="absolute h-44 w-44 rounded-full bg-navy-50" data-id="element-1768" data-mp="2dmme0cod2ve5" />
        <span className="relative flex h-24 w-24 -translate-x-8 items-center justify-center rounded-2xl bg-bdgreen-600 text-white shadow-lg" data-id="element-1769" data-mp="28lggm1jrajya"><CarTaxiFront className="h-12 w-12" data-id="element-1770" data-mp="23preprk9kqyt" /></span>
        <span className="absolute flex h-20 w-20 translate-x-10 translate-y-8 items-center justify-center rounded-2xl bg-navy-800 text-white shadow-lg" data-id="element-1771" data-mp="x7urggdwcicr"><Bike className="h-10 w-10" data-id="element-1772" data-mp="sakvsizwzagh" /></span>
        <span className="absolute -translate-y-14 translate-x-14 flex h-11 w-11 items-center justify-center rounded-full bg-white text-navy-800 shadow" data-id="element-1773" data-mp="3ra6pgh61mofh"><Smartphone className="h-5 w-5" data-id="element-1774" data-mp="3vbig8q0nlfp9" /></span>
      </div>
}, {
  title: 'গাড়ির তথ্য ও কাগজপত্র যাচাই করুন',
  body: 'প্রয়োজনীয় তথ্য ও ডকুমেন্ট জমা দিয়ে যাচাইয়ের আবেদন করুন।',
  art: <div className="relative flex h-full items-center justify-center" data-id="element-1775" data-mp="3m9sg8vsph8fv">
        <span className="absolute h-44 w-44 rounded-full bg-bdgreen-50" data-id="element-1776" data-mp="37lxkt7nbcpz3" />
        <div className="relative w-36 rounded-xl border border-slate-200 bg-white p-3 shadow-lg" data-id="element-1777" data-mp="3cdz072fs2wtc">
          {[80, 60, 70, 45].map((w, i) => <span key={i} className="mb-2 block h-2 rounded-full bg-slate-200" style={{
        width: `${w}%`
      }} data-id="element-1778" data-mp="2ynvlqxn547eg" data-mpi={i} />)}
          <span className="mt-3 flex items-center gap-1 text-[10px] font-semibold text-emerald-700" data-id="element-1779" data-mp="33irdrxsdmurk"><FileCheck className="h-3.5 w-3.5" data-id="element-1780" data-mp="2opxyacd3uemw" />তথ্য মিলেছে</span>
        </div>
        <span className="absolute translate-x-16 translate-y-12 flex h-14 w-14 items-center justify-center rounded-full bg-bdgreen-600 text-white shadow-lg" data-id="element-1781" data-mp="2tmg31c8fqcz8"><ShieldCheck className="h-7 w-7" data-id="element-1782" data-mp="25rw5m570tqcb" /></span>
      </div>
}, {
  title: 'সকল আপডেট পান মোবাইলে',
  body: 'আবেদনের অবস্থা, QR স্টিকার, কাগজপত্রের মেয়াদ ও গুরুত্বপূর্ণ নোটিফিকেশন দেখুন।',
  art: <div className="relative flex h-full items-center justify-center" data-id="element-1783" data-mp="1vu7z6i01yueb">
        <span className="absolute h-44 w-44 rounded-full bg-amber-50" data-id="element-1784" data-mp="2th6xsyab2ceu" />
        <span className="relative flex h-24 w-24 items-center justify-center rounded-2xl border-4 border-navy-800 bg-white text-navy-900 shadow-lg" data-id="element-1785" data-mp="2tgfccgaf9v2a"><QrCode className="h-14 w-14" data-id="element-1786" data-mp="2jiral6eefnam" /></span>
        <span className="absolute -translate-x-16 -translate-y-10 flex h-12 w-12 items-center justify-center rounded-full bg-amber-500 text-white shadow-lg" data-id="element-1787" data-mp="2jhg4v11e85gv"><BellRing className="h-6 w-6" data-id="element-1788" data-mp="183m55umvvanb" /></span>
      </div>
}];
export function OwnerOnboarding({
  nav
}: {
  nav: OwnerNav;
}) {
  const [i, setI] = useState(0);
  const s = slides[i];
  const goTo = (n: number) => setI(Math.max(0, Math.min(slides.length - 1, n)));
  return <div className="flex h-full flex-col bg-white" data-id="element-1789" data-mp="3eq9ydghsh7gs">
      <div className="flex items-center justify-between px-5 pt-3" data-id="element-1790" data-mp="3jrzbr2shhx81">
        <DmpLogo size={34} data-id="element-1791" data-mp="3opsgdre52j67" />
        {i < slides.length - 1 && <button onClick={() => goTo(slides.length - 1)} className="text-sm font-medium text-slate-500" data-id="element-1792" data-mp="3oo7ok9j7lec1">এড়িয়ে যান</button>}
      </div>
      <div className="relative flex-1 overflow-hidden" data-id="element-1793" data-mp="2bhdpj9jw39c">
        <AnimatePresence mode="wait" data-id="element-1794" data-mp="2d29fc7lps8s">
          <motion.div key={i} initial={{
          opacity: 0,
          x: 40
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -40
        }} transition={{
          duration: 0.25
        }} drag="x" dragConstraints={{
          left: 0,
          right: 0
        }} onDragEnd={(_, info) => {
          if (info.offset.x < -60) goTo(i + 1);
          if (info.offset.x > 60) goTo(i - 1);
        }} className="flex h-full cursor-grab flex-col px-7 active:cursor-grabbing" data-id="element-1795" data-mp="6bjkg6u57mvh">
            <div className="h-64 pt-6" data-id="element-1796" data-mp="cbqlaxqip9ia">{s.art}</div>
            <h1 className="mt-6 text-center font-heading text-2xl font-bold leading-snug text-navy-900" data-id="element-1797" data-mp="7f07kh26qq01">{s.title}</h1>
            <p className="mt-3 text-center text-[15px] leading-relaxed text-slate-600" data-id="element-1798" data-mp="ld85ar71pvc9">{s.body}</p>
          </motion.div>
        </AnimatePresence>
      </div>
      <div className="flex justify-center gap-2 pb-5" role="tablist" aria-label="পরিচিতি স্লাইড" data-id="element-1799" data-mp="3pshitlu4h8z9">
        {slides.map((_, n) => <button key={n} role="tab" aria-selected={n === i} aria-label={`স্লাইড ${n + 1}`} onClick={() => goTo(n)} className={`h-2 rounded-full transition-all ${n === i ? 'w-6 bg-navy-800' : 'w-2 bg-slate-300'}`} data-id="element-1800" data-mp="3kufy6wh1t1lo" data-mpi={n} />)}
      </div>
      <div className="space-y-2.5 px-5 pb-6" data-id="element-1801" data-mp="3tsrunf4litm1">
        {i < slides.length - 1 ? <OwnerButton onClick={() => goTo(i + 1)} data-id="element-1802" data-mp="362xkx6fkpl60">পরবর্তী</OwnerButton> : <OwnerButton variant="green" onClick={() => nav.go('register')} data-id="element-1803" data-mp="3223y6gdvacep">শুরু করুন</OwnerButton>}
        <OwnerButton variant="outline" onClick={() => nav.go('login')} data-id="element-1804" data-mp="2ry6s2gfvwddu">লগইন করুন</OwnerButton>
      </div>
    </div>;
}